import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  app: {
    minHeight: '100vh',
  },
  // Fixed ambient mark behind all content, held to the right of the 1200px
  // content column (its original hero spot). z-index -1 sits above the body
  // background but beneath page content, so glass panels can frost it.
  signatureLayer: {
    position: 'fixed',
    top: '50%',
    right: 'max(2vw, calc((100vw - 1200px) / 2 + 2vw))',
    transform: 'translateY(-50%)',
    width: 'clamp(320px, 40vw, 560px)',
    aspectRatio: '1 / 1',
    zIndex: -1,
    pointerEvents: 'none',
  },
};
